<div class="d-flex flex-column align-items-center justify-content-center gap-2">
  <div
    *ngIf="fabStore.scroll"
    class="box--one"
    (click)="onAction(actionTypes.scroll)"
  >
    <i class="bi bi-arrow-up"></i>
  </div>
  <div
    *ngIf="fabStore.plus"
    class="box--one"
    [ngClass]="fabStore.title ? 'text-btn px-3' : ''"
    (click)="onAction(actionTypes.plus)"
  >
    <i class="bi bi-plus-lg"></i>
    <span class="ms-1">{{ fabStore.title }}</span>
  </div>
  <div
    *ngIf="fabStore.heart"
    class="box--one"
    (click)="onAction(actionTypes.heart)"
  >
    <i class="bi bi-heart-fill"></i>
  </div>
</div>
